import { useEffect } from "react";
import "./forms.css";
import {
  EmailAuthProvider,
  GoogleAuthProvider,
  // MicrosoftAuthProvider,
} from "firebase/auth";
import { auth } from "./firebase";
import { Scrollbars } from "react-custom-scrollbars-4";
// import firebase from "firebase/compat/app";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { Toolbar, Typography, Stack } from "@mui/material";

function Login() {
  useEffect(() => {
    // const ui = new firebaseui.auth.AuthUI(firebase.auth());
    const ui =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

    // const msProvider = new OAuthProvider("microsoft.com");

    // // Optional: Add custom parameters (e.g., to specify 'common' tenant)
    // msProvider.setCustomParameters({
    //   prompt: "consent",
    //   tenant: "common", // Use 'common' for multi-tenant/personal accounts
    // });

    // console.log(MicrosoftAuthProvider.PROVIDER_ID);

    ui.start("#firebaseuiauthcontainer", {
      signInOptions: [
        "microsoft.com",
        // {
        //   provider: FacebookAuthProvider.PROVIDER_ID,
        //   requireDisplayName: true,
        // },
        {
          provider: GoogleAuthProvider.PROVIDER_ID,
          requireDisplayName: true,
        },
        {
          provider: EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: true,
        },
      ],
      signInSuccessUrl: "/account",
      // Popup sign-in flow to display the FirebaseUI widget.
      signInFlow: "popup",
      // Terms of service url.
      tosUrl: "/tos",
      // Privacy policy url.
      privacyPolicyUrl: "/privacy",
    });
  }, []);

  return (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <div style={{ marginTop: 100 }} id="firebaseuiauthcontainer" />

      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        style={{ margin: 16 }}
      >
        <Typography align={"center"}>
          By logging in, you are agreeing to the Terms of Service and Privacy
          Policy.
        </Typography>
      </Stack>
    </Scrollbars>
  );
}

export default Login;
